import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { buildQueryString } from 'src/lib/utilities/api/http';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import {
	PathfinderOutboundRequestArgument,
	PathfinderOutboundRequestModel,
	PathfinderViewRequestModel,
} from './alai-pathfinder.model';

@Injectable({
	providedIn: 'root',
})
export class AlaiPathfinderService {
	constructor(private httpClient: HttpClient) {}

	public outboundRequest = (
		args: PathfinderOutboundRequestArgument,
	): Observable<PathfinderOutboundRequestModel> => {
		return this.httpClient
			.post<unknown>(
				`/api/v1/external_services/alai_pathfinder/process_request`,
				args,
			)
			.pipe(
				mapResponse((r) => plainToInstance(PathfinderOutboundRequestModel, r), {
					errorCode: 'B4B21160',
				}),
			);
	};

	public viewRequests = (
		student_uid?: number,
		current: boolean = true,
	): Observable<PathfinderViewRequestModel[]> => {
		const query = buildQueryString({
			student_uid: student_uid,
			current: current,
		});

		return this.httpClient
			.get<{
				results: unknown[];
			}>(`/api/v1/external_services/alai_pathfinder/requests${query}`)
			.pipe(
				mapResponse(
					(r) => plainToInstance(PathfinderViewRequestModel, r.results),
					{
						errorCode: 'EB962071',
					},
				),
			);
	};
}
